const selfcheckoutTotem = () => {
  const isSelfcheckoutTotem = window.location.pathname.includes(
    "/autoatendimento/totem-"
  );
  return isSelfcheckoutTotem;
};

export default selfcheckoutTotem;
